/* === Little Whiskers Master Native Cart & Interaction Engine === */

const Sound = {
  ctx: null,
  init() {
    if (!this.ctx) this.ctx = new (window.AudioContext || window.webkitAudioContext)();
    if (this.ctx.state === 'suspended') this.ctx.resume();
  },
  crunch() {
    this.init();
    const bufferSize = this.ctx.sampleRate * 0.08;
    const buffer = this.ctx.createBuffer(1, bufferSize, this.ctx.sampleRate);
    const data = buffer.getChannelData(0);
    for (let i = 0; i < bufferSize; i++) data[i] = Math.random() * 2 - 1;
    const noise = this.ctx.createBufferSource();
    noise.buffer = buffer;
    const filter = this.ctx.createBiquadFilter();
    filter.type = 'bandpass';
    filter.frequency.value = 1400;
    const gain = this.ctx.createGain();
    gain.gain.setValueAtTime(0.3, this.ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.01, this.ctx.currentTime + 0.08);
    noise.connect(filter);
    filter.connect(gain);
    gain.connect(this.ctx.destination);
    noise.start();
  },
  chime(freq = 880) {
    this.init();
    const osc = this.ctx.createOscillator();
    const gain = this.ctx.createGain();
    osc.type = 'sine';
    osc.frequency.setValueAtTime(freq, this.ctx.currentTime);
    gain.gain.setValueAtTime(0.25, this.ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, this.ctx.currentTime + 1.2);
    osc.connect(gain);
    gain.connect(this.ctx.destination);
    osc.start();
    osc.stop(this.ctx.currentTime + 1.2);
  }
};

/* --- Drawer Controls --- */
function toggleCart(open) {
  const drawer = document.getElementById('cartDrawer');
  const overlay = document.getElementById('cartOverlay');
  if (!drawer || !overlay) return;
  if (open) {
    drawer.classList.add('open');
    overlay.classList.add('open');
    fetchShopifyCart();
  } else {
    drawer.classList.remove('open');
    overlay.classList.remove('open');
  }
}

/* --- Real AJAX Shopify Cart Integration --- */
const LW_FREE_DELIVERY_THRESHOLD = 1499; // ₹ — keep in sync with your Shopify shipping rate

function lwEscape(str) {
  return String(str == null ? '' : str)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

function lwRupees(paise) {
  return '₹' + (paise / 100).toLocaleString('en-IN', { maximumFractionDigits: 2 });
}

function lwToast(message) {
  let toast = document.getElementById('lwToast');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'lwToast';
    toast.setAttribute('role', 'status');
    toast.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:100000;background:#230407;color:#ECC474;border:1.5px solid #ECC474;padding:12px 20px;border-radius:30px;font-weight:700;font-size:0.9rem;box-shadow:0 8px 24px rgba(0,0,0,0.3);max-width:90vw;text-align:center;';
    document.body.appendChild(toast);
  }
  toast.textContent = message;
  toast.style.display = 'block';
  clearTimeout(toast._t);
  toast._t = setTimeout(() => { toast.style.display = 'none'; }, 4000);
}

/* Used by the product page "Add to Bag" button */
function addToBag(variantId, quantity) {
  Sound.crunch();
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
  })
  .then(res => res.json().then(data => ({ ok: res.ok, data })))
  .then(({ ok, data }) => {
    if (!ok) {
      lwToast(data.description || data.message || "Couldn't add that to your bag. Please try again.");
      return;
    }
    toggleCart(true);
  })
  .catch(() => lwToast("Couldn't add that to your bag. Please check your connection and try again."));
}
function fetchShopifyCart() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => lwSyncDeliveryFees(cart).then(changed => changed ? fetch('/cart.js').then(r => r.json()) : cart))
    .then(cart => renderCartUI(cart))
    .catch(err => console.error("Error fetching cart:", err));
}

/* Hampers sent to a different address (under the free threshold) carry a hidden "_fee_variant".
   Keep exactly one "Extra delivery address" charge per such hamper line, adding/removing it as needed.
   Resolves to true if the cart was changed. */
function lwSyncDeliveryFees(cart) {
  const need = {};
  const have = {};
  (cart.items || []).forEach((it) => {
    const p = it.properties || {};
    if (p._fee_variant) need[p._fee_variant] = (need[p._fee_variant] || 0) + 1;
    if (p._fee === '1') have[String(it.id)] = { key: it.key, qty: it.quantity };
  });
  const ids = new Set([...Object.keys(need), ...Object.keys(have)]);
  const ops = [];
  ids.forEach((id) => {
    const want = need[id] || 0;
    const cur = have[id] ? have[id].qty : 0;
    if (want === cur) return;
    if (have[id]) {
      ops.push(() => fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: have[id].key, quantity: want })
      }));
    } else {
      ops.push(() => fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: want, properties: { _fee: '1' } }] })
      }));
    }
  });
  if (!ops.length) return Promise.resolve(false);
  return ops.reduce((chain, op) => chain.then(op), Promise.resolve()).then(() => true).catch(() => false);
}

function renderCartUI(cart) {
  const countBadge = document.getElementById('cartCountBadge');
  if (countBadge) countBadge.innerText = cart.item_count;

  const list = document.getElementById('cartItemsList');
  const subtotalEl = document.getElementById('cartSubtotal');
  const bar = document.getElementById('shippingBar');
  const pctText = document.getElementById('shippingPercent');
  const notice = document.getElementById('shippingNotice');

  if (!list) return;

  if (cart.item_count === 0) {
    lwSyncNoteDiscount(cart);
    list.innerHTML = `<p style="text-align: center; opacity: 0.6; margin-top: 40px;">Your bag is empty! Fill it with fresh bakes.</p>`;
    if (subtotalEl) subtotalEl.innerText = '₹0';
    if (bar) bar.style.width = '0%';
    if (pctText) pctText.innerText = '0%';
    if (notice) notice.innerText = `Add ₹${LW_FREE_DELIVERY_THRESHOLD.toLocaleString('en-IN')} more for FREE delivery`;
    return;
  }

  list.innerHTML = cart.items.map((item, index) => {
    let propertiesHtml = '';
    if (item.properties) {
      for (const [key, value] of Object.entries(item.properties)) {
        if (!value || key.charAt(0) === '_') continue;
        const shown = String(value).indexOf(' × ') > -1
          ? String(value).split(', ').map(lwEscape).join('<br>')
          : lwEscape(value);
        propertiesHtml += `<div style="font-size:0.75rem; opacity:0.85; line-height:1.45; margin-bottom:3px;"><strong>${lwEscape(key)}:</strong><br>${shown}</div>`;
      }
    }
    const lineNumber = index + 1;
    const isFee = item.properties && item.properties._fee === '1';
    if (isFee) {
      return `
      <div style="display: flex; gap: 12px; align-items: center; padding: 12px 0; border-bottom: 1px solid var(--blush, #f3d7dc);">
        <div style="width: 60px; height: 60px; border-radius: 12px; border: 1px solid var(--blush, #f3d7dc); display: grid; place-items: center; font-size: 1.6rem; flex-shrink: 0;">🛵</div>
        <div style="flex-grow: 1;">
          <strong style="display: block; color: var(--cherry); font-size: 0.9rem; line-height: 1.3; margin-bottom: 2px;">${lwEscape(item.product_title)}${item.quantity > 1 ? ' × ' + item.quantity : ''}</strong>
          <div style="font-size:0.75rem; opacity:0.75; line-height:1.4;">For hampers going to a different address. Updates automatically.</div>
          <div style="font-weight: 800; font-size: 0.85rem; color: var(--cherry); margin-top: 2px;">${lwRupees(item.final_line_price)}</div>
        </div>
      </div>`;
    }
    return `
      <div style="display: flex; gap: 12px; align-items: center; padding: 14px 0; border-bottom: 1px solid var(--blush, #f3d7dc);">
        ${item.image ? `<img src="${item.image}" alt="${lwEscape(item.product_title)}" style="width: 60px; height: 60px; object-fit: cover; border-radius: 12px; border: 1px solid var(--blush, #f3d7dc);">` : ''}
        <div style="flex-grow: 1;">
          <strong style="display: block; color: var(--cherry); font-size: 0.9rem; line-height: 1.3; margin-bottom: 4px;">${lwEscape(item.product_title)}</strong>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div style="font-size:0.75rem; opacity:0.7; margin-bottom: 4px; line-height: 1.4;">${lwEscape(item.variant_title)}</div>` : ''}
          ${propertiesHtml}
          <div style="font-weight: 800; font-size: 0.85rem; color: var(--cherry); margin-top: 2px;">${lwRupees(item.final_line_price)}</div>
        </div>
        <!-- Quantity Controls (- / +) -->
        <div style="display: flex; align-items: center; gap: 6px; background: var(--blush-light, #fbf0f2); padding: 4px 8px; border-radius: 20px; border: 1px solid var(--blush, #f3d7dc);">
          <button type="button" aria-label="Decrease quantity" onclick="updateItemQuantity(${lineNumber}, ${item.quantity - 1})" style="background:none; border:none; font-weight:900; cursor:pointer; color:var(--cherry); font-size:1rem; padding: 0 4px;">−</button>
          <span style="font-size: 0.85rem; font-weight: 800; min-width: 16px; text-align: center;">${item.quantity}</span>
          <button type="button" aria-label="Increase quantity" onclick="updateItemQuantity(${lineNumber}, ${item.quantity + 1})" style="background:none; border:none; font-weight:900; cursor:pointer; color:var(--cherry); font-size:1rem; padding: 0 4px;">+</button>
        </div>
        <!-- Clean Styled Delete Button -->
        <button type="button" onclick="updateItemQuantity(${lineNumber}, 0)" title="Remove item" aria-label="Remove ${lwEscape(item.product_title)}" style="background: var(--blush-light, #fbf0f2); border: 1px solid var(--blush, #f3d7dc); border-radius: 50%; width: 28px; height: 28px; display: flex; align-items: center; justify-content: center; cursor: pointer; color: var(--cherry); font-size: 0.8rem; font-weight: 800; flex-shrink: 0;">✕</button>
      </div>
    `;
  }).join('');

  lwSyncNoteDiscount(cart);

  const totalRupees = cart.total_price / 100;
  if (subtotalEl) subtotalEl.innerText = `₹${totalRupees.toLocaleString('en-IN')}`;

  const threshold = LW_FREE_DELIVERY_THRESHOLD;
  const pct = Math.min(100, Math.round((totalRupees / threshold) * 100));
  if (bar) bar.style.width = `${pct}%`;
  if (pctText) pctText.innerText = `${pct}%`;
  if (notice) {
    if (totalRupees >= threshold) {
      notice.innerText = '🎉 You\'ve unlocked FREE delivery!';
    } else {
      notice.innerText = `Add ₹${Math.ceil(threshold - totalRupees).toLocaleString('en-IN')} more for FREE delivery`;
    }
  }
}

/* Handwritten note written without AI → carry its discount code to checkout */
function lwSyncNoteDiscount(cart) {
  let code = '';
  (cart.items || []).forEach((item) => {
    if (item.properties && item.properties._note_code) code = item.properties._note_code;
  });
  const link = document.getElementById('lwCheckoutLink');
  if (link) link.href = code ? '/checkout?discount=' + encodeURIComponent(code) : '/checkout';
  const msg = document.getElementById('lwNoteDiscount');
  if (msg) msg.hidden = !code;
}

function updateItemQuantity(line, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: line, quantity: qty })
  })
  .then(res => res.json())
  .then(cart => lwSyncDeliveryFees(cart).then(changed => changed ? fetch('/cart.js').then(r => r.json()) : cart))
  .then(cart => renderCartUI(cart))
  .catch(() => lwToast("Couldn't update your bag. Please try again."));
}

function handleAjaxAddToCart(event, form) {
  event.preventDefault();
  Sound.crunch();
  const formData = new FormData(form);
  fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  })
  .then(res => res.json().then(data => ({ ok: res.ok, data })))
  .then(({ ok, data }) => {
    if (!ok) { lwToast(data.description || "Couldn't add that to your bag."); return; }
    toggleCart(true);
  })
  .catch(() => lwToast("Couldn't add that to your bag. Please try again."));
}

/* --- Diya Particles Animation --- */
let diyaModeActive = true;

function toggleDiyaMode() {
  diyaModeActive = !diyaModeActive;
  document.body.classList.toggle('diya-mode', diyaModeActive);
  try { localStorage.setItem('lw_diya_mode_v2', diyaModeActive); } catch (e) {}
  const text = document.getElementById('diyaBtnText');
  if (text) text.innerText = diyaModeActive ? "Diya Mode: ON" : "Diya Mode: OFF";
  Sound.chime(540);
  if (diyaModeActive) startDiyaParticles();
}

const lwReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
let lwDiyaRunning = false;

function startDiyaParticles() {
  const canvas = document.getElementById('diyaCanvas');
  if (!canvas || lwReducedMotion || lwDiyaRunning) return;
  lwDiyaRunning = true;
  const ctx = canvas.getContext('2d');
  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;

  const particles = Array.from({ length: 48 }, () => ({
    x: Math.random() * canvas.width,
    y: canvas.height + Math.random() * 120,
    size: Math.random() * 3.5 + 1.2,
    speedY: Math.random() * 1.6 + 0.6,
    opacity: Math.random() * 0.7 + 0.3
  }));

  function animate() {
    if (!document.body.classList.contains('diya-mode')) {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      lwDiyaRunning = false;
      return;
    }
    if (document.hidden) { requestAnimationFrame(animate); return; }
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    particles.forEach(p => {
      p.y -= p.speedY;
      if (p.y < -10) p.y = canvas.height + 10;
      ctx.fillStyle = `rgba(255, 215, 0, ${p.opacity})`;
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
      ctx.fill();
    });
    requestAnimationFrame(animate);
  }
  window.addEventListener('resize', () => {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
  });
  animate();
}

/* --- Lo-Fi Ambient Sound Engine --- */
const LofiEngine = {
  isPlaying: false,
  timer: null,
  vinylNode: null,
  masterGain: null,
  chords: [
    [261.63, 329.63, 392.00, 493.88],
    [220.00, 261.63, 329.63, 392.00],
    [174.61, 220.00, 261.63, 329.63],
    [196.00, 246.94, 293.66, 392.00]
  ],
  idx: 0,
  start() {
    Sound.init();
    const ctx = Sound.ctx;
    this.isPlaying = true;
    this.masterGain = ctx.createGain();
    this.masterGain.gain.setValueAtTime(0.18, ctx.currentTime);
    this.masterGain.connect(ctx.destination);

    const bufLen = ctx.sampleRate * 2;
    const nBuf = ctx.createBuffer(1, bufLen, ctx.sampleRate);
    const out = nBuf.getChannelData(0);
    for (let i = 0; i < bufLen; i++) {
      out[i] = (Math.random() * 2 - 1) * 0.04;
      if (Math.random() < 0.0018) out[i] += (Math.random() * 2 - 1) * 0.45;
    }
    this.vinylNode = ctx.createBufferSource();
    this.vinylNode.buffer = nBuf;
    this.vinylNode.loop = true;
    const vFilter = ctx.createBiquadFilter();
    vFilter.type = 'lowpass';
    vFilter.frequency.value = 1600;
    const vGain = ctx.createGain();
    vGain.gain.value = 0.45;
    this.vinylNode.connect(vFilter);
    vFilter.connect(vGain);
    vGain.connect(this.masterGain);
    this.vinylNode.start();

    this.playChords();
  },
  playChords() {
    if (!this.isPlaying) return;
    const ctx = Sound.ctx;
    const notes = this.chords[this.idx];
    this.idx = (this.idx + 1) % this.chords.length;

    notes.forEach((freq, i) => {
      const osc = ctx.createOscillator();
      const noteGain = ctx.createGain();
      const filter = ctx.createBiquadFilter();
      osc.type = 'sine';
      osc.frequency.setValueAtTime(freq, ctx.currentTime + i * 0.06);
      filter.type = 'lowpass';
      filter.frequency.setValueAtTime(800, ctx.currentTime);
      const startTime = ctx.currentTime + i * 0.06;
      noteGain.gain.setValueAtTime(0.0001, startTime);
      noteGain.gain.linearRampToValueAtTime(0.04, startTime + 0.15);
      noteGain.gain.exponentialRampToValueAtTime(0.0001, startTime + 3.2);
      osc.connect(filter);
      filter.connect(noteGain);
      noteGain.connect(this.masterGain);
      osc.start(startTime);
      osc.stop(startTime + 3.4);
    });

    this.timer = setTimeout(() => this.playChords(), 3400);
  },
  stop() {
    this.isPlaying = false;
    if (this.timer) clearTimeout(this.timer);
    if (this.vinylNode) {
      try { this.vinylNode.stop(); } catch(e){}
      this.vinylNode.disconnect();
    }
  }
};

function toggleLofiSound() {
  const btn = document.getElementById('lofiToggleBtn');
  const text = document.getElementById('lofiText');
  const icon = document.getElementById('lofiIcon');
  if (!LofiEngine.isPlaying) {
    LofiEngine.start();
    btn.classList.add('playing');
    text.innerText = 'Bakery Lo-Fi: ON';
    icon.innerText = '☕';
  } else {
    LofiEngine.stop();
    btn.classList.remove('playing');
    text.innerText = 'Bakery Lo-Fi: OFF';
    icon.innerText = '📻';
  }
}

window.addEventListener('DOMContentLoaded', () => {
  let saved = null;
  try { saved = localStorage.getItem('lw_diya_mode_v2'); } catch (e) {}
  if (saved === 'false') {
    diyaModeActive = false;
    document.body.classList.remove('diya-mode');
    const txt = document.getElementById('diyaBtnText');
    if (txt) txt.innerText = "Diya Mode: OFF";
  } else {
    diyaModeActive = true;
    document.body.classList.add('diya-mode');
    const txt = document.getElementById('diyaBtnText');
    if (txt) txt.innerText = "Diya Mode: ON";
    startDiyaParticles();
  }
});

/* Keep the cart badge accurate (e.g. after using the back button) */
window.addEventListener('pageshow', () => {
  fetch('/cart.js').then(res => res.json()).then(cart => {
    return lwSyncDeliveryFees(cart).then(changed => {
      if (changed && location.pathname.indexOf('/cart') === 0) { location.reload(); return; }
      if (changed) return fetch('/cart.js').then(r => r.json());
      return cart;
    });
  }).then(cart => {
    if (!cart) return;
    const badge = document.getElementById('cartCountBadge');
    if (badge) badge.innerText = cart.item_count;
  }).catch(() => {});
});

/* Escape closes the cart drawer and mobile menu */
document.addEventListener('keydown', (e) => {
  if (e.key !== 'Escape') return;
  toggleCart(false);
  const menu = document.getElementById('lwMobileDrawer');
  if (menu && menu.classList.contains('active') && typeof toggleMobileMenu === 'function') toggleMobileMenu();
});
